import React from 'react';
import theme from '../../theme';
import { IconProps } from './props'

const LogoutIcon: React.FC<IconProps> = ({ id, iconColor = theme.textDark, ...rest }) => (
    <svg
        id={id}
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.57812 4.26538C5.31291 4.26538 5.05855 4.37074 4.87102 4.55827C4.68348 4.74581 4.57812 5.00016 4.57812 5.26538V19.2654C4.57812 19.5306 4.68348 19.785 4.87102 19.9725C5.05855 20.16 5.31291 20.2654 5.57812 20.2654H9.57812C10.1304 20.2654 10.5781 20.7131 10.5781 21.2654C10.5781 21.8177 10.1304 22.2654 9.57812 22.2654H5.57812C4.78247 22.2654 4.01941 21.9493 3.4568 21.3867C2.8942 20.8241 2.57812 20.061 2.57812 19.2654V5.26538C2.57812 4.46973 2.8942 3.70667 3.4568 3.14406C4.01941 2.58145 4.78248 2.26538 5.57812 2.26538H9.57812C10.1304 2.26538 10.5781 2.7131 10.5781 3.26538C10.5781 3.81767 10.1304 4.26538 9.57812 4.26538H5.57812Z"
            fill={iconColor} />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.871 6.55827C16.2615 6.16775 16.8947 6.16775 17.2852 6.55827L22.2852 11.5583C22.6758 11.9488 22.6758 12.582 22.2852 12.9725L17.2852 17.9725C16.8947 18.363 16.2615 18.363 15.871 17.9725C15.4805 17.582 15.4805 16.9488 15.871 16.5583L20.1639 12.2654L15.871 7.97249C15.4805 7.58196 15.4805 6.9488 15.871 6.55827Z"
            fill={iconColor} />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.57812 12.2654C8.57812 11.7131 9.02584 11.2654 9.57812 11.2654H21.5781C22.1304 11.2654 22.5781 11.7131 22.5781 12.2654C22.5781 12.8177 22.1304 13.2654 21.5781 13.2654H9.57812C9.02584 13.2654 8.57812 12.8177 8.57812 12.2654Z"
            fill={iconColor} />
    </svg>
);

export { LogoutIcon };